const api = require('./api')

exports.get = api.get
exports.list = api.list
exports.listUsersByRole = api.listUsersByRole
exports.listUsersByRoutes = api.listUsersByRoutes
exports.rolesDefinition = api.rolesDefinition

exports.prepareUserToSave = api.prepareUserToSave
exports.create = api.create
exports.update = api.update
exports.savePharmacyUser = api.savePharmacyUser
exports.assignRoute = api.assignRoute
